module.exports = __webpack_public_path__ + "img/bluebook-2016.e495da7e.jpg";